<template>
  <div>
    <condition-part
      :hasDate="true"
      :hasFood="isDetail"
      :hasFoodKind="isDetail"
      :hasEmployee="true"
      :hasDirectory="true"
      :hasWarehouse="true"
      :hasExcel="true"
      :hasPdf="true"
      :hasAdd="false"
      :hasEdit="false"
      :hasRemove="false"
      :columns="columns"
      :items="items"
      :pagination="pagination"
      :isSortable="true"
      @getItems="getItems"
      @downloadExcel="downloadExcel"
      @downloadPdf="downloadPdf"
      @printPdf="printPdf"
      :reportTypes="reportTypes"
    ></condition-part>
  </div>
</template>

<script>
import conditionPart from "@/components/parts/conditionPart";

export default {
  data() {
    return {
      items: [],
      pagination: {},
      reportTypes: ["simple", "detail"],
      reportType: "simple",
    };
  },
  computed: {
    columns() {
      if (this.reportType == "detail") {
        let s = [
          { name: "StockAdjustDate" },
          { name: "StockAdjustNumber" },
          { name: "StockAdjustType" },
          { name: "DirectoryName" },
          { name: "WarehouseNumber" },
          { name: "WarehouseName" },
          { name: "EmployeeNumber" },
          { name: "EmployeeName" },
          { name: "TradeMemo" },
          { name: "FoodNumber" },
          { name: "FoodName" },
          { name: "Qty" },
          { name: "Memo" },
        ];
        if (window.localStorage["hasBatchNumber"] == "true") {
          s.push({ name: "BatchNumber" });
        }
        return s;
      } else if (this.reportType == "simple") {
        return [
          { name: "StockAdjustDate" },
          { name: "StockAdjustNumber" },
          { name: "StockAdjustType" },
          { name: "DirectoryName" },
          { name: "EmployeeNumber" },
          { name: "EmployeeName" },
          { name: "Memo" },
        ];
      } else {
        return undefined;
      }
    },
    isDetail() {
      return this.reportType == "detail";
    },
  },
  components: {
    conditionPart,
  },
  methods: {
    downloadExcel(condition) {
      this.$api.reportExcels.getStockAdjust(condition);
    },
    downloadPdf(condition) {
      this.$api.reportPdfs.getStockAdjust(condition);
    },
    printPdf(condition) {
      this.$api.reportPdfs.printStockAdjust(condition);
    },
    getItems(condition) {
      this.reportType = condition.ReportType;

      const vm = this;
      this.$api.reports.getStockAdjust(condition).then((data) => {
        vm.items = data.Datas;
        vm.pagination = data.Pagination;
      });
    },
  },
};
</script>
